/**
 * Bunny AI Gateway
 * Security-first AI gateway. One API. Every model. Total protection. All `/v1/_*` endpoints are transparently proxied to the underlying AI Gateway runtime. Use a valid API key in the `Authorization` header.
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Expires } from './expires';

export interface ApiKeyCreateData {
  key_id: string;
  secret: string;
  name?: string | null;
  user_id?: string | null;
  models?: string[];
  max_budget?: number | null;
  expires?: Expires | null;
  status?: ApiKeyCreateData.StatusEnum;
  metadata?: object | null;
  tpm_limit?: number | null;
  rpm_limit?: number | null;
  max_parallel_requests?: number | null;
  region?: string;
}
export namespace ApiKeyCreateData {
  export type StatusEnum = 'active' | 'blocked';
  export const StatusEnum = {
    active: 'active' as StatusEnum,
    blocked: 'blocked' as StatusEnum,
  };
}
